import { Link } from "react-router-dom";
import { GraduationCap } from "lucide-react";

export function Logo({ variant = "dark", className = "" }) {
  const light = variant === "light";
  return (
    <Link to="/" data-testid="site-logo" className={`flex items-center gap-2 group ${className}`}>
      <span className="relative flex items-center justify-center w-9 h-9 rounded-xl bg-gold text-navy-dark shadow-md group-hover:scale-105 transition-transform">
        <GraduationCap size={20} strokeWidth={2.4} />
      </span>
      <span className="leading-none">
        <span className={`font-display text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-navy"}`}>
          Lock<span className="gold-text">My</span>College
        </span>
        <span className={`block text-[10px] tracking-[0.28em] uppercase mt-0.5 ${light ? "text-white/60" : "text-muted-foreground"}`}>
          Discover · Compare · Decide
        </span>
      </span>
    </Link>
  );
}
